{
  "passengersSelect": {
    "passengers": {
      "amount": "0 пассажиров | {n} пассажир | {n} пассажира | {n} пассажиров",
      "adults": "Взрослые",
      "adultShort": "{n} взр",
      "children": "Дети",
      "childShort": "{n} дет",
      "infants": "Младенцы",
      "infantShort": "{n} мл"
    },
    "cabinClass": {
      "economy": "эконом",
      "business": "бизнес класс",
      "youth": "молодежный тариф"
    }
  }
}
